document.querySelectorAll('.preview-blog-section').forEach((section) => {
  const SWIPER_SELECTOR = '[data-swiper]';
  const NEXT_BUTTON_SELECTOR = '[data-next-swiper]';
  const PREV_BUTTON_SELECTOR = '[data-prev-swiper]';
  
  const swiperEl = section.querySelector(SWIPER_SELECTOR);
  const nextEl = section.querySelector(NEXT_BUTTON_SELECTOR);
  const prevEl = section.querySelector(PREV_BUTTON_SELECTOR);

  new Swiper(swiperEl, {
    loop: false,
    navigation: {
      addIcons: false,
      nextEl,
      prevEl,
    },
    spaceBetween: 25,
    pagination: false,
    slidesPerView: 'auto',
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
  });
});

